import { useState } from 'react'
import { api, hooks } from 'roadie-ui'

type CandidateData = {
  business_name?: string
  business_size?: string
  first_name?: string
  last_name?: string
  email?: string
  phone_number?: string
  password?: string
}

// type CandidateData = {
//   [k: string]: string
// }

const useCandidateToken = () => {
  const [data, setData] = useState<CandidateData>({})
  const [loading, setLoading] = useState(true)

  hooks.useOnce(() => {
    api
      .get('v3/prospect', {
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Source-Application': 'ROADIE_WEB_PORTALS',
          'X-Api-Key': import.meta.env.REACT_APP_PROSPECT_API_KEY,
        },
      })
      .then((resp) => {
        if (resp.data.phone_number) {
          resp.data.phone_number = resp.data.phone_number.replace(/\D/g, '')
        }
        setData(resp.data)
      })
      .catch(() => {
        //Catch error but don't do anything with it.
        // It just means there was no data to retrieve
      })
      .finally(() => {
        setLoading(false)
      })
  })

  return { data, loading }
}

export default useCandidateToken
